module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_9006.4b24d3aa.png";